module.exports = __WEBPACK_EXTERNAL_MODULE_123__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 123
// module chunks = 0